import React, { useEffect, useState } from 'react';
import { Layout, Card, Row, Col, Button, Typography, Select, List, Avatar, Divider, Modal, Form, InputNumber, Input, message, Tooltip } from 'antd';
import {
  UserOutlined
} from '@ant-design/icons';
import "./karma.css";
import gift from '../../assets/KarmaIcons/gift.png';
import partyGIF from '../../assets/KarmaIcons/partyGIF.gif';
import UpGraph from '../../assets/KarmaIcons/UpGraph';
import HistoryIcon from '../../assets/KarmaIcons/HistoryIcon';
import Trophylsner from '../../assets/KarmaIcons/waffle.png';
import totalWaffel from '../../assets/KarmaIcons/mothlyWaff.png';
import remaingWaffle from '../../assets/KarmaIcons/remaingWaffle.png';
import sendwaffle from '../../assets/KarmaIcons/totalWaffel.png';
import Top1 from '../../assets/KarmaIcons/top1.png';
import Top2 from '../../assets/KarmaIcons/top2.png';
import Top3 from '../../assets/KarmaIcons/top3.png';
import Top4 from '../../assets/KarmaIcons/top4.png';
import Top5 from '../../assets/KarmaIcons/top5.png';





import ltr from '../../assets/KarmaIcons/ltr.svg';

import axios from "axios";

import config from "../../permission/config.json"

import DownIcon from '../../assets/KarmaIcons/DownIcon';
import Service from '../../service';
import { useDispatch, useSelector } from 'react-redux';
import { hideAuthLoader } from '../../appRedux/actions/Auth';

import moment from 'moment'
import Trophy from '../../assets/KarmaIcons/Trophy';
import { getResource } from '../../util/getResourcePermission';
import WaffleDashIcon from '../../assets/KarmaIcons/Spark';
import { ORGANIZATION_TREE, React_profile_url } from '../../constants/permission_id';
import useCompanyDateFormat from '../../hooks/useCompanyDateFormat';
const {  Content } = Layout;
const { Title, Text } = Typography;
const { Option } = Select;
const topImages = [Top1, Top2, Top3, Top4, Top5];

const Karmasend = (props) => {
  const dateFormat = useCompanyDateFormat();
  const [classToggel, setClassToggel] = useState(false);
  const [karmaistoryData, setKarmaistoryData] = useState([])
  const [performersData, setperformersData] = useState([])
  const [karmaLeaderboardData, setkarmaLeaderboardData] = useState([])
  const [hasMore, setHasMore] = useState(true);
  const [isSendWaffleModalOpen, setisSendWaffleModalOpen] = useState(false);
  const [selectedEmployees, setSelectedEmployees] = useState([]); 
  const [selectedEmployeesemail, setSelectedEmployeesEmail] = useState(null);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [catgryNAme, setCatgryNAme] = useState("");
  const [isWaffleAmountDisabled, setIsWaffleAmountDisabled] = useState(true);
  const [hasMorep, setHasMorep] = useState(true);
  const [totalRect, settotalRect] = useState(null)
  const { authUser } = useSelector(({ auth }) => auth);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
  });
  const [paginationp, setPaginationp] = useState({
    current: 1,
    pageSize: 25,
  });
  const [form] = Form.useForm();
  const [empdropdown, setEmpDropdown] = useState([])

  const dispatch = useDispatch()
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedValue, setSelectedValue] = useState(null);

  const karmaStats = [
    {
      value: authUser?.karma_balance==-1?"Unlimited":authUser?.karma_balance,
      label: 'Waffle Left',
      icon: <img src={ remaingWaffle } height={ 55 } width={ 55 } />,

    },
    {
      value: authUser?.total_remaining_karma,
      label: 'Received',
      icon: <img src={ Trophylsner } width={ 55 } height={ 55 } />,
    },
    {
      value: authUser?.karma_sending_balance==-1 ?'Unlimited': authUser?.karma_sending_balance ,
      label: 'Monthly Waffle',
      icon: <img src={ totalWaffel } height={ 55 } width={ 55 } />,
    },
  ];
  const getKarmaRewards = async (pageNum = 1, pageLimit = 5) => {
    try {
      const response = await Service.makeAPICall({
        methodName: Service.postMethod,
        api_url: Service.get_karma_history,
        body: {
          pageNum: pageNum,
          pageLimit: 5,
        },
      });

      if (response.status) {
        dispatch(hideAuthLoader());

        settotalRect(response?.data?.pagination?.totalRecords)
        const newData = response?.data?.data || [];
        if (pageNum === 1) {
          setKarmaistoryData(newData); 
        } else {
          setKarmaistoryData((prevData) => [...prevData, ...newData]);
        }
        setPaginationp((prev) => ({ ...prev, current: pageNum }));

        setHasMorep(
          newData.length === pageLimit &&
          (pageNum * paginationp.pageSize) < response?.data?.pagination?.totalRecords
        );
      }
    } catch (error) {
      console.error("Failed to fetch rewards:", error);
    }
  };

  const performance = async () => {
    try {
      const response = await Service.makeAPICall({
        methodName: Service.getMethod,
        api_url: Service.performanceWaffle,
      });

      if (response.status) {
        dispatch(hideAuthLoader());
        setperformersData(response?.data?.data)
      }
    } catch (error) {
      console.error("Failed to fetch rewards:", error);
    }
  };


  const karmaLeaderboard = async (pageNum = 1) => {
    try {
      const response = await Service.makeAPICall({
        methodName: Service.postMethod,
        api_url: Service.karmaLeaderboard,
        body: {
          pageNum: pageNum,
          pageLimit: 5,
        },
      });

      if (response.status) {
        dispatch(hideAuthLoader());

        const newData = response?.data?.data || [];
        if (pageNum === 1) {
          setkarmaLeaderboardData(newData); 

        } else {
          setkarmaLeaderboardData((prevData) => [...prevData, ...newData]); 
        }
        setPagination((prev) => ({ ...prev, current: pageNum }));
        setHasMore(newData.length === pagination.pageSize); 

      }
    } catch (error) {
      console.error("Failed to fetch leaderboard:", error);
    }
  };


  const wafflecategry = async () => {
    try {
      const response = await Service.makeAPICall({
        methodName: Service.getMethod,
        api_url: Service.wafflecategry,
      });

      if (response.status) {
        dispatch(hideAuthLoader());
        setSelectedCategories(response?.data?.data)
      }
    } catch (error) {
      console.error("Failed to fetch rewards:", error);
    }
  };

  const handleShowMore = () => {
    const nextPage = pagination.current + 1;
    setPagination((prev) => ({ ...prev, current: nextPage }));
    karmaLeaderboard(nextPage); 
  };

  const handleShowMorePerformance = () => {
    const nextPage = paginationp.current + 1;
    setPaginationp((prev) => ({ ...prev, current: nextPage }));
    getKarmaRewards(nextPage); 
  };

  const handleEconnectAPI = async (value) => {
    try {

      let reqBody = {
        email: authUser?.email,
        receiver_email: selectedEmployeesemail,
        reason: catgryNAme,
      }

       const response = await axios.post(
        process.env.REACT_APP_WAFFLE_FROM_HRMS,
        reqBody,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.data && response.data.status) {
        dispatch(hideAuthLoader());
        handleCancelWffleSend()
      } else {
        message.error(response?.data?.message)

      }
    } catch (error) {
      console.error("Failed to fetch rewards:", error);
    }

  }

  const handleSendWaffle = async (value) => {
    try {

      let reqBody = {
        sender_id: authUser?._id,
        receiver_ids: selectedEmployees
        ,
        transaction_type: "send_by_admin",
        message: catgryNAme,
        transaction_amount: value?.waffleAmount
      }

      const response = await Service.makeAPICall({
        methodName: Service.postMethod,
        api_url: Service.karmaSend,
        body: reqBody
      });

      if (response.data.data) {
        dispatch(hideAuthLoader());
        setperformersData(response?.data?.data)
        handleEconnectAPI(value)
        performance()
        handleCancelWffleSend()
        getKarmaRewards(1, 5)
      } else {
        message.error(response?.data?.message)

      }
    } catch (error) {
      console.error("Failed to fetch rewards:", error);
    }

  }


  const handleCancelWffleSend = () => {
    setisSendWaffleModalOpen(false)
    form.resetFields();
  }
  const getEmpdropdown = async () => {
    try {
      const response = await Service.makeAPICall({
        methodName: Service.getMethod,
        api_url: Service.employee,

      });
      if (response.data && response.data.data) {
        const emp = response.data.data;
        setEmpDropdown(emp);
      }
    } catch (error) {
      console.log(error);
    }
  };


  const karmaRewardCreate = async () => {
    try {
      if (selectedValue == null) {
        return message.error('Selecte Waffle Amount');
      }
      const response = await Service.makeAPICall({
        methodName: Service.postMethod,
        api_url: Service.karmaRewardCreate,
        body: { waffle_amount_selected: selectedValue },
      });

      if (response.status) {
        if (response.data.status == 400) {
          message.error(response.data.message);
        } else {
          dispatch(hideAuthLoader());
          message.success('Reward redemption requested successfully');
          handleCancel()
         }
      }
    } catch (error) {
      console.error("Validation Failed:", error);
    }
  }

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleChange = (value) => {
    setSelectedValue(value);
  };
  useEffect
    (() => {
      setTimeout(() => {
        setClassToggel(false)
      }, 5000);
    }, [classToggel]);


  useEffect(() => { getKarmaRewards(1); performance(); karmaLeaderboard(1); }, [])
  const maxSelectable = Math.floor(authUser?.total_remaining_karma / 100) * 100; 
  const options = Array.from({ length: maxSelectable / 100 }, (_, i) => (i + 1) * 100);
  
  
  return (
    <Layout className={ classToggel ? "karma-wrapper partygif" : "karma-wrapper" }>
      <img src={ partyGIF } className="gift-img" />
      <Content className="rewards-container">
        <div className="content-wrapper">
          <Card className="welcome-card">
            <div className="welcome-container">
              <div className="welcome-title ">
                <h2>
                  Waffle Dashboard! <WaffleDashIcon />
                </h2>

              </div>

              <div className="welcome-text">
                <h3>
                  Recognise effort. Reward excellence. Build a stronger {authUser?.companyId?.companyName}.
                </h3>
              </div>

            </div>
          </Card>

          <Card className="stats-card">
            <Row gutter={ [16, 16] } className='karma-card-wrapper'>
              { karmaStats.map((stat, index) => (
                <Col xs={ 24 } sm={ 8 } key={ index }>
                  <Card className="karma-stat-card">
                    <div className="karma-icon-container">{ stat.icon }</div>
                    <Title level={ 2 } className="karma-value">{ stat.value }</Title>
                    <Text type="secondary" className="karma-label">{ stat.label }</Text>
                  </Card>
                </Col>
              )) }
            </Row>
          </Card>

          <Row gutter={ 24 } className='karma-button-wrapper'>

            { getResource(config.RESOURCES.WAFFLE, ['create']) &&
              <Tooltip
                title="Send an Waffle to someone who made a difference. Add a personal message too!">
                <Button type="primary" icon={ <img src={ sendwaffle } width={ 20 } height={ 20 }></img> } onClick={ () => {
                  setisSendWaffleModalOpen(true);
                  getEmpdropdown(); wafflecategry()
                } } className="send-karma-btn">
                  <strong> Send Waffle</strong>
                  <div id="container-stars">
                    <div id="stars"></div>
                  </div>
                  <div id="glow">
                    <div class="circle"></div>
                    <div class="circle"></div>
                  </div>
                </Button>
              </Tooltip>

            }
            <Tooltip

              title="Use your earned Waffle to unlock rewards.">
              <Button className="redeem-rewards-btn btn-shine"
                onClick={ showModal }>
                <span>
                  <img src={ gift } />
                  Waffle Rewards</span>
              </Button>
            </Tooltip>
          </Row>

          <Row gutter={ 24 } className='history-main-wrapper'>
            <Col xs={ 24 } lg={ 12 } >
              <Card className="stats-card top-performers-card">
                <div className="performers-header-wrapper">
                  <Tooltip title="Track every Waffle you’ve sent or received – with reason, date and messages.">
                    <div className='top-performers-header'>
                      <HistoryIcon />
                      <h2 className="history-title"> Waffle Transaction History</h2>
                    </div>
                  </Tooltip>


                </div>
                <Divider />
                <div className=" transaction-list">
                  {karmaistoryData.length > 0 ?
                    karmaistoryData?.map((transaction, index) => (
                      <> <div key={transaction?._id} className="transaction-item">
                        <div className="transaction-info">
                          {transaction?.transaction_type == "send_by_admin" && transaction?.sender_email == authUser._id
                            ? <img src={ltr} width={30} height={30} />
                            : transaction?.sender_email !== authUser._id
                              ? <UpGraph />
                              : <DownIcon />
                          }


                          <div className="transaction-details">
                            <p
                              className="transaction-description"
                              dangerouslySetInnerHTML={{
                                __html:
                                  transaction?.message +
                                  (transaction?.transaction_type === "send_by_admin"
                                    ? `&nbsp;(Send Via HRMS)`
                                    : ""),
                              }}
                            ></p>
                            <p className="transaction-date"><span>{transaction?.receiver_id == authUser?._id ? transaction?.sender_name : transaction?.receiver_name}</span></p>
                          </div>
                          <span className='waffle-transaction-time'>
                            {moment(new Date(transaction.createdAt)).format(dateFormat)}</span>
                        </div>
                        <p className={`transaction-amount ${transaction?.sender_email != authUser._id ? 'amount-earned' : 'amount-spent'
                          }`}>
                          {transaction?.transaction_type == "send_by_admin" && transaction?.sender_email == authUser._id ?
                            <>
                              <div style={{ color: '#f18f06' }}>{transaction?.transaction_amount}</div>
                            </> :
                            <>

                              {transaction?.sender_email != authUser?._id ? '+' : '-'}{transaction?.transaction_amount}
                            </>}
                        </p>
                      </div>
                        {index === karmaistoryData.length - 1 && hasMorep && (
                          <div style={{ textAlign: "center", marginTop: 16 }}>
                            <Button type="primary" className="redeem-button" onClick={handleShowMorePerformance}>
                              Show More
                            </Button>
                          </div>
                        )}</>

                    )) : <div style={{ textAlign: "center", color: '#ccc' }}>
                      <p>No Transaction History available</p>
                    </div>
                  }
                </div>
              </Card>
            </Col>
            <Col xs={ 24 } lg={ 12 }>

              <Card className="stats-card top-performers-card"
              >
                <div className='performers-header-wrapper'>
                  <Tooltip title='Meet the stars of the month – recognised by peers for going above and beyond.'>
                    <div className='top-performers-header'>
                      <Trophy />
                      <h2>Top Performers</h2>
                    </div>
                  </Tooltip>
                   </div>
                <Divider />
                <List
                  dataSource={ performersData }
                  locale={ {
                    emptyText: (
                      <div style={ { textAlign: "center" } }>
                        <p>No Performers available</p>
                      </div>
                    ),
                  } }
                  renderItem={ (item, index) => (
                    <>
                      <List.Item
                      >
                        <div className='performers-wrapper'>
                          <List.Item.Meta
                            avatar={
                              <>
                                <div style={ { display: 'flex', gap: '5px' } }>
                                  <Avatar
                                    src={ topImages[index] }
                                  >
                                  </Avatar>

                                  { item?.emp_img ? (
                                    <Avatar src={ `${React_profile_url}/uploads/emp_images/${item?.emp_img}` } />
                                  ) : (
                                    <UserOutlined />
                                  ) }
                                </div> 
                              </>
                            }
                          />
                          <div className='performers-name-wrapper'>
                            <div className='performers-name'>
                              <h3>{ item?.full_name }</h3>
                            </div>
                            <div className='performers-title'>
                              <p>{ item?.userdepartmentDetails?.designation_name } </p>
                            </div>
                          </div>
                        </div>
                        <div className='points-wrapper'>
                          <Text >
                            { item?.total_received_karma }
                          </Text>
                          <span role="img" aria-label="lightning" >
                            <img src={ Trophylsner } height={ 20 } width={ 20 } /> </span>
                        </div>
                      </List.Item>
                    </>

                  ) }

                />


              </Card>
            </Col>
          </Row>
          <Row gutter={ 24 } className='leaderboard-card-wrapper'>
            <Col xs={ 24 }>
              <Card className="stats-card leaderboard-card top-performers-card"
              >

                <div className='performers-header-wrapper'>
                  <Tooltip title="See who's climbing the Waffle leaderboard this year across teams.
">
                    <div className='top-performers-header'>
                      <Trophy />
                      <h2>Leaderboard</h2>
                    </div>
                  </Tooltip>
                </div>
                <Divider />
                <List
                  dataSource={ karmaLeaderboardData }
                  renderItem={ (item, index) => (
                    <>
                      <List.Item>
                        <div className='performers-wrapper'>
                          <List.Item.Meta
                            avatar={ <Avatar src={ `${React_profile_url}/uploads/emp_images/` + item?.emp_img } />
                            }
                          />
                          <div className='performers-name-wrapper'>
                            <div className='performers-name'>
                              <h3>{ item?.full_name }</h3>
                            </div>
                            <div className='performers-title'>
                              <p>{ item?.designation?.designation_name }</p>
                            </div>
                          </div>
                        </div>
                        <div className='points-wrapper'>
                          <Text>{ item?.total_received_karma || 0 }</Text>
                          <span role="img" aria-label="lightning"><img src={ Trophylsner } height={ 20 } width={ 20 } alt='emp_img' /> </span>
                        </div>
                      </List.Item>

                      { index === karmaLeaderboardData.length - 1 && hasMore && (
                        <div style={ { textAlign: "center", marginTop: 16 } }>
                          <Button type="primary" className="redeem-button" onClick={ handleShowMore }>
                            Show More
                          </Button>
                        </div>
                      ) }

                    </>
                  ) }
                />
              </Card>
            </Col>
          </Row>

          <Modal
            className='waffle-modal'
            title="Send Waffle"
            open={ isSendWaffleModalOpen }
            onCancel={ handleCancelWffleSend }
            footer={ null }
          >
            <Form form={ form } layout="vertical" onFinish={ handleSendWaffle }>

              <Form.Item label="Employee" name="employee" required={ true }>
                <Select
                defaultValue="Select"
                  size="large"
                  showSearch
                  optionFilterProp="children"
                  filterOption={ (input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                  filterSort={ (optionA, optionB) =>
                    optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                  }
                  placeholder="Select an employee"
                  onChange={ (selectedId) => {
                    setSelectedEmployees([selectedId]); // Store as an array with one value
                    let selectedEmployee = empdropdown.find((emp) => emp._id === selectedId);
                    let employeeCode = selectedEmployee ? selectedEmployee?.email : "";
                    setSelectedEmployeesEmail(employeeCode)

                    form.setFieldsValue({ employee_code: [selectedId] });
                  } }
                >
                  { empdropdown.map((item) => (
                    <Option key={ item._id } value={ item._id } style={ { textTransform: "capitalize" } }>
                      { item.first_name + " " + item.last_name }
                    </Option>
                  )) }
                </Select>
              </Form.Item>


              <Form.Item name="category" label="Select Category" rules={ [{ required: true, message: "Please select a category!" }] }>
                <Select
                  defaultValue="Select"
                  onChange={ (selectedCategory) => {
                    const selected = selectedCategories.find((cat) => cat._id === selectedCategory);
                    setCatgryNAme(selected.category)
                    form.setFieldsValue({ waffleAmount: selected ? selected.waffle_count : null });
                    setIsWaffleAmountDisabled(!selected); 
                  } }
                >
                  { selectedCategories.map((category) => (
                    <Option key={ category._id } value={ category._id }>
                      { category?.category }
                    </Option>
                  )) }
                </Select>
              </Form.Item>

              <Form.Item name="message" label="Message" rules={ [{ required: true, message: "Please enter a message!" }] }>
                <Input.TextArea placeholder="Write a message..." rows={ 3 } />
              </Form.Item>

              <Form.Item
                name="waffleAmount"
                label="Waffle Amount"
                rules={ [{ required: true, message: "Enter waffle amount!" }] }
              >
                <InputNumber
                  min={ 1 }
                  max={ 100 }
                  style={ { width: "100%" } }
                  disabled={ true } 
                />
              </Form.Item>

              <div>
                <Button key="cancel" className='ant-delete' onClick={ handleCancelWffleSend }>
                  Cancel
                </Button>
                <Button key="send" type="primary" className='redeem-button' htmlType="submit" style={ { marginLeft: '10px' } } >
                  Send Waffle
                </Button>
              </div>

            </Form>
          </Modal>


          <Modal
            className='waffle-modal'
            title="Select a Value"
            open={ isModalVisible }
            onCancel={ handleCancel }
            footer={ [
              <Button key="cancel" className='ant-delete' onClick={ handleCancel }>
                Cancel
              </Button>,
              <Button key="submit" type="primary" className='redeem-button' disabled={ maxSelectable <= 99 } onClick={ () => { karmaRewardCreate() } }>
               Save
              </Button>,
            ] }
          >
            { maxSelectable <= 99 ? <>
              Max Waffle Limit 100</> : <Select
                required={ true }
                defaultValue="Select"
                style={ { width: "100%" } }
                onChange={ handleChange }
              >

              { options?.map((value) => (
                <Option key={ value } value={ value }>
                  { value }
                </Option>
              )) }
            </Select> }


          </Modal>
        </div>

      </Content>
    </Layout>
  );
};

export default Karmasend;
